import React from 'react';
import { getDic } from '../../assets/i18n/dictionary';
import {
  FormRow,
  FormColumn,
  TextMedium,
  TextSmall,
  Card,
  Button,
  Image,
} from '../../components';

const Step1Instructions = ({
  dimensions,
  configOptions,
  setCurrentStep,
}) => {

  const width = dimensions.width < 640 ? dimensions.width - 40 : 600;

  return (
    <FormColumn paddingTop={20} justifyContent='center' alignItems='center'>
      <FormRow justifyContent='center'>
        <FormColumn padding={5}>
          <FormRow width={width}>
            <TextMedium fontWeight='bold' color={configOptions.textColor}>
              {getDic("face-collector-step-1-a")}
            </TextMedium>
          </FormRow>
          <FormRow width={width} paddingTop={10}>
            <TextSmall color={configOptions.textColor}>
              {getDic("face-collector-step-1-b")}
            </TextSmall>
          </FormRow>
        </FormColumn>
      </FormRow>
      <FormRow justifyContent='center' paddingTop={25}>
        <FormColumn>
          <Card>
            <FormColumn height={150} justifyContent='center'>
              <FormRow width={width / 2 - 5} justifyContent='center'>
                <FormColumn paddingBottom={10}>
                  <Image height={50} width={80} url={require('../../assets/icons/Headsets.png')} />
                </FormColumn>
              </FormRow>
              <FormRow width={width / 2 - 5} justifyContent='center'>
                <TextSmall fontWeight='bold'>
                  <spam style={{ color: 'red' }}>{getDic("nao").toUpperCase()}</spam> {getDic("face-collector-step-1-c")}
                </TextSmall>
              </FormRow>
            </FormColumn>
          </Card>
        </FormColumn>
        <FormColumn width={10}></FormColumn>
        <FormColumn>
          <Card>
            <FormColumn height={150} justifyContent='center'>
              <FormRow width={width / 2 - 5} justifyContent='center'>
                <FormColumn paddingBottom={25}>
                  <Image height={50} width={120} url={require('../../assets/icons/Oculos.png')} />
                </FormColumn>
              </FormRow>
              <FormRow width={width / 2 - 5} justifyContent='center'>
                <TextSmall fontWeight='bold'>
                  <spam style={{ color: 'red' }}>{getDic("nao").toUpperCase()}</spam> {getDic("face-collector-step-1-d")}
                </TextSmall>
              </FormRow>
            </FormColumn>
          </Card>
        </FormColumn>
      </FormRow>
      <FormRow justifyContent='center' paddingTop={10}>
        <FormColumn>
          <Card>
            <FormColumn height={150} justifyContent='center'>
              <FormRow width={width / 2 - 5} justifyContent='center'>
                <FormColumn paddingBottom={15}>
                  <Image height={50} width={80} url={require('../../assets/icons/Luz.png')} />
                </FormColumn>
              </FormRow>
              <FormRow width={width / 2 - 5} justifyContent='center'>
                <TextSmall fontWeight='bold'>
                  <spam style={{ color: 'green' }}>OK</spam> {getDic("face-collector-step-1-e")}
                </TextSmall>
              </FormRow>
            </FormColumn>
          </Card>
        </FormColumn>
        <FormColumn width={10}></FormColumn>
        <FormColumn>
          <Card>
            <FormColumn height={150} justifyContent='center'>
              <FormRow width={width / 2 - 5} justifyContent='center'>
                <FormColumn paddingBottom={17}>
                  <Image height={50} width={90} url={require('../../assets/icons/Fundo-Branco.png')} />
                </FormColumn>
              </FormRow>
              <FormRow width={width / 2 - 5} justifyContent='center'>
                <TextSmall fontWeight='bold'>
                  <spam style={{ color: 'green' }}>OK</spam> {getDic("face-collector-step-1-f")}
                </TextSmall>
              </FormRow>
            </FormColumn>
          </Card>
        </FormColumn>
      </FormRow>
      <FormRow justifyContent='flex-end' width={width} paddingTop={30}>
        <FormColumn width={width / 2 - 10}>
          <Button
            textColor={configOptions.buttonTextColor}
            background={configOptions.buttonBackgroundColor}
            text={getDic("avancar")}
            onPress={() => setCurrentStep(2)}
          />
        </FormColumn>
      </FormRow>
    </FormColumn>
  )
};

export default Step1Instructions;
